function redirectToTaxonomy(e) {
  e.preventDefault(); // Previene l'invio del form

  const type = document.querySelector('select[name="type"]')?.value || '';
  const location = document.querySelector('select[name="location"]')?.value || '';
  const price = document.querySelector('select[name="price"]')?.value || '';
  const rooms = document.querySelector('select[name="rooms"]')?.value || '';
  const mq = document.querySelector('select[name="mq"]')?.value || '';

  // Aggiungi i parametri di query se non sono vuoti
  const params = new URLSearchParams();
  if (type) params.append("type", type);
  if (location) params.append("location", location);
  if (price) params.append("price", price);
  if (rooms) params.append("rooms", rooms);
  if (mq) params.append("mq", mq);

  const qs = "?" + params.toString();

  // Reindirizza alla URL della tassonomia con i parametri

  if (!type && window.ortica.search.isTax) {
    window.location.href =
      window.ortica.search.archiveLink + "?" + params.toString();
    return false;
  }

  if (!window.ortica.search.isTax) {
    window.location.href =
      window.ortica.search.archiveLink + "?" + params.toString();
    return true;
  }

  let url = window.ortica.search.baseUrl + (type ? type + "/" : "");

  window.location.href = url + qs;
}

let searchForm = document.querySelector(".o-search-form");
if (searchForm) {
  searchForm.addEventListener("submit", redirectToTaxonomy);
}
